import { formatCurrency } from "../../../../services/format";
import { connectListView, ListView, ListViewColumnType } from "../../../UI/view/list-view";
import { voidedTransactionsDS } from "./data-source";

export const columns = [
  {
    Header: 'Order Number',
    accessor: 'paymentSourceBatchNumber',
    type: ListViewColumnType.link,
    linkPath: ({ val, row }) => row.original.url,
    newLink: true
  },
  {
    Header: 'Customer #',
    accessor: 'customerId',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row: { original: { amount } } }) => formatCurrency(amount),
  },
  {
    Header: 'Authorization #',
    id: 'authorizationNumber',
    accessor: ({ authorizationNumber }) => authorizationNumber,
  },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    defaultSort: true,
    defaultSortDirection: 'desc',
    type: ListViewColumnType.date
  },
];
export const voided = {
  columns: columns
} as ListView;

export const [Voided, _] = connectListView(voided, voidedTransactionsDS);